export const searchFields = [
  {
    name: "Quality",
    options: [
      {
        name: "All",
        value: "all",
      },
      {
        name: "480p",
        value: "480p",
      },
      {
        name: "720p",
        value: "720p",
      },
      {
        name: "1080p",
        value: "1080p",
      },
      {
        name: "2160p",
        value: "2160p",
      },
      {
        name: "3D",
        value: "3D",
      },
    ],
  },
  {
    name: "Genre",
    options: [
      {
        name: "All",
        value: "all",
      },
      {
        name: "Action",
        value: "action",
      },
      {
        name: "Adventure",
        value: "adventure",
      },
      {
        name: "Animation",
        value: "animation",
      },
      {
        name: "Biography",
        value: "biography",
      },
      {
        name: "Comedy",
        value: "comedy",
      },
      {
        name: "Crime",
        value: "crime",
      },
      {
        name: "Documentary",
        value: "documentary",
      },
      {
        name: "Drama",
        value: "drama",
      },
      {
        name: "Family",
        value: "family",
      },
      {
        name: "Fantasy",
        value: "fantasy",
      },
      {
        name: "Film-Noir",
        value: "film-noir",
      },
      {
        name: "Game-Show",
        value: "game-show",
      },
      {
        name: "History",
        value: "history",
      },
      {
        name: "Horror",
        value: "horror",
      },
      {
        name: "Music",
        value: "music",
      },
      {
        name: "Musical",
        value: "musical",
      },
      {
        name: "Mystery",
        value: "mystery",
      },
      {
        name: "News",
        value: "news",
      },
      {
        name: "Reality-TV",
        value: "reality-tv",
      },
      {
        name: "Romance",
        value: "romance",
      },
      {
        name: "Sci-Fi",
        value: "sci-fi",
      },
      {
        name: "Sport",
        value: "sport",
      },
      {
        name: "Talk-Show",
        value: "talk-show",
      },
      {
        name: "Thriller",
        value: "thriller",
      },
      {
        name: "War",
        value: "war",
      },
      {
        name: "Western",
        value: "western",
      },
    ],
  },
  {
    name: "Rating",
    options: [
      {
        name: "All",
        value: "0",
      },
      {
        name: "9+",
        value: "9",
      },
      {
        name: "8+",
        value: "8",
      },
      {
        name: "7+",
        value: "7",
      },
      {
        name: "6+",
        value: "6",
      },
      {
        name: "5+",
        value: "5",
      },
      {
        name: "4+",
        value: "4",
      },
      {
        name: "3+",
        value: "3",
      },
      {
        name: "2+",
        value: "2",
      },
      {
        name: "1+",
        value: "1",
      },
    ],
  },
  {
    name: "Sort By",
    options: [
      {
        name: "Title",
        value: "title",
      },
      {
        name: "Year",
        value: "year",
      },
      {
        name: "Rating",
        value: "rating",
      },
      {
        name: "Seeds",
        value: "seeds",
      },
      {
        name: "Downloads",
        value: "downloads",
      },
      {
        name: "Likes",
        value: "like_count",
      },
      {
        name: "Date added",
        value: "date_added",
      },
    ],
  },
  {
    name: "Order By",
    options: [
      {
        name: "Ascending",
        value: "asc",
      },
      {
        name: "Descending",
        value: "desc",
      },
    ],
  },
];
